import React from 'react'
import { FaThumbsDown, FaThumbsUp } from "react-icons/fa";


// Data array containing safety tips
const safetyTips = [
    {
      type: "Don'ts",
      icon: <FaThumbsDown className="text-red-500 mr-2 inline" />,
      points: [
        "The second step from the top of a stepladder.",
        "The fourth rung from the top of an extension ladder."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/mTapy61hYBaNM1JfnjJkKnuHtd5ieOMNlz8oLkgmvKE33VnTA.jpg",
      aos: "fade-right"
    },
    {
      type: "Do's",
      icon: <FaThumbsUp className="text-green-500 mr-2 inline" />,
      points: [
        "For safe ladder use, wear non-slip shoes and follow setup instructions.",
        "Don shoes with good traction and set up the ladder per safety guidelines."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/Rvk7MBe9LyRzSSKe31ghzS5MbpdeQ8MG1D1H2NteMjj2eu6cC.jpg",
      aos: "fade-left"
    },
    {
      type: "Don'ts",
      icon: <FaThumbsDown className="text-red-500 mr-2 inline" />,
      points: [
        "Don't climb on the back of a stepladder. It's not designed for weight there.",
        "Don't stand or sit on the top step shelf. It's not a work platform."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/JS0FKqdMsILXExKoLfhznnh3IXSaJ700xlBoS5Dfs0zs3VnTA.jpg",
      aos: "fade-right"
    },
    {
      type: "Do's",
      icon: <FaThumbsUp className="text-green-500 mr-2 inline" />,
      points: [
        "Always face the ladder: Maintain eye contact with the rungs for safe climbing.",
        "Steady climb, one foot at a time. Secure each step before reaching higher."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/xPwhydEykjJWLpWxw0DT62W4mjdU1yKweTDltml4aVu57qzJA.jpg",
      aos: "fade-left"
    },
  
    {
      type: "Don'ts",
      icon: <FaThumbsDown className="text-red-500 mr-2 inline" />,
      points: [
        "Closed ladders are a no-go: They can easily slip and cause a fall.",
        "Don't use a ladder with visible damage, including bent rungs or loose steps."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/Mw704wnFksJmD9SC4LXvGGWEZBaCttc4UTUrTIiQAre87qzJA.jpg",
      aos: "fade-right"
    },
    {
      type: "Do's",
      icon: <FaThumbsUp className="text-green-500 mr-2 inline" />,
      points: [
        "Stay centered, buckle up: Keep your body close and secure within the ladder rails.",
        "Firm grip on rungs ensures safe, controlled climbing movement."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/NnXc0ue2GDxWNST9jGeSidUiOSg3YArUG2lAUhIYPHYx3VnTA.jpg",
      aos: "fade-left"
    },
  
    {
      type: "Do's",
      icon: <FaThumbsUp className="text-green-500 mr-2 inline" />,
      points: [
        "Weight limit? Respect it: Don't overload, stay within the ladder's safe zone.",
        "One ladder, one person: Share the sturdier option, double duty for single ladders."
      ],
      imageUrl: "https://storage.googleapis.com/a1aa/image/zGBrWRZ1BaIyPRvP1e1CxfBf81oQFGx8OOmPoIaWXLceeu6cC.jpg",
      aos: "fade-right"
    },
    // Add more tips as needed
  ];

const SafetyTip = () => {
  return (
    <>
    <section className="w-full lg:w-4/5 mx-auto p-5">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-semibold mx-auto py-5 max-w-xl leading-normal text-[#142a4e]" data-aos="fade-down">
            Aluminium Ladder
            <span className="text-[#f57d21]"> Safety Tips</span> - Do's & Don'ts
          </h2>
        </div>

        <div className="flex flex-wrap justify-between text-[15px] text-neutral-700">
          {/* Iterate through safetyTips array */}
          {safetyTips.map((tip, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg w-full sm:w-[48%] mb-5 flex flex-col sm:flex-row overflow-hidden transition-transform duration-200 hover:transform hover:-translate-y-1 hover:shadow-2xl"
              data-aos={tip.aos}
            >
              <img
                alt={`Tip Image ${index + 1}`}
                src={tip.imageUrl}
                className="w-full sm:w-[40%] object-cover transition-transform duration-200 hover:scale-105"
              />
              <div className="p-5 w-full sm:w-[60%] flex flex-col justify-center">
                <h3 className="text-xl font-semibold text-[#f57d21]">{tip.type}</h3>
                {tip.points.map((point, idx) => (
                  <p key={idx} className="mt-2">
                    {tip.icon} {point}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}

export default SafetyTip